import "./App.css";
// import ARScene from "./ARScene";
import XRScene from "./XRScene";

function App() {
  if (process.env.NODE_ENV === "production") {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = {
      supportsFiber: true,
      inject: () => {},
      onCommitRoot: () => {},
      onCommitFiberUnmount: () => {},
    };
  }
  return (
    <div className="App">
      <XRScene />
    </div>
  );
}

export default App;
